import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {ToggleWhatsAppIsEnabled as ToggleWhatsAppIsEnabledMutation} from 'nutshell-graphql-types';

import TOGGLE_WHATSAPP_IS_ENABLED from '../mutations/toggle-whatsapp-is-enabled.graphql';
import GET_WHATSAPP_INTEGRATION from '../queries/get-whatsapp-integration.graphql';

export const useToggleWhatsAppIsEnabled = (): {
    toggleWhatsAppIsEnabled: (isEnabled: boolean) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [toggleWhatsAppIsEnabled, {loading, error}] = useMutation<
        ToggleWhatsAppIsEnabledMutation,
        Record<any, any>
    >(TOGGLE_WHATSAPP_IS_ENABLED);

    return {
        toggleWhatsAppIsEnabled: (isEnabled: boolean) => {
            return toggleWhatsAppIsEnabled({
                optimisticResponse: {
                    toggleWhatsAppIsEnabled: {
                        __typename: 'WhatsAppIntegration',
                        hasAuthToken: true,
                        isEnabled: !isEnabled,
                        userPhoneNumber: '1234567890',
                    },
                },
                update: (cache, {data}) => {
                    if (!data) {
                        return;
                    }

                    const existingData = cache.readQuery({
                        query: GET_WHATSAPP_INTEGRATION,
                    });

                    if (!existingData) {
                        return;
                    }

                    cache.writeQuery({
                        query: GET_WHATSAPP_INTEGRATION,
                        data: {
                            whatsAppIntegration: {
                                // @ts-expect-error
                                ...existingData.whatsAppIntegration,
                                isEnabled: !isEnabled,
                            },
                        },
                    });
                },
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
